import { QuoteElement } from "../../lib/quote-element.js";
import { property, customElement } from "lit/decorators.js";
import "../../common/legal-disclaimer.js";
import "../../common/descriptor-list.js";
import "../../common/promotional-description.js";
import "../../common/offer-header.js";
import "../../common/landing-page-action.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let TicketRefund = class extends QuoteElement {
  constructor() {
    super("ticket-refund");
  }
  /**
   * @ignore
   */
  get policyAttributes() {
    return {
      insurable_amount: this.insurableAmount,
      event_start_date: this.eventStartDate,
      event_end_date: this.eventEndDate
    };
  }
};
TicketRefund.styles = [
  QuoteElement.styles
];
__decorateClass([
  property({ type: Number, attribute: "insurable-amount" })
], TicketRefund.prototype, "insurableAmount", 2);
__decorateClass([
  property({ attribute: "event-start-date" })
], TicketRefund.prototype, "eventStartDate", 2);
__decorateClass([
  property({ attribute: "event-end-date" })
], TicketRefund.prototype, "eventEndDate", 2);
TicketRefund = __decorateClass([
  customElement("ticket-refund")
], TicketRefund);
export {
  TicketRefund
};
